import { PhaseNameCase, StepNameCase, StepStatusCaseData } from '@/interfaces';
import React from 'react';

interface Props {
	caseSteps: StepStatusCaseData | undefined;
	phaseName: PhaseNameCase;
	stepName: StepNameCase;
}

export const usePhaseStatus = ({ caseSteps, phaseName, stepName }: Props) => {
	const [phaseId, setPhaseId] = React.useState<number>();
	const [stepId, setStepId] = React.useState<number>();

	React.useEffect(() => {
		if (phaseName && caseSteps) {
			const currentPhase = caseSteps.status.find((item) =>
				phaseName.includes(item.fase_name)
			);
			setPhaseId(currentPhase?.fase_id);
		}
	}, [phaseName, caseSteps]);

	React.useEffect(() => {
		if (stepName && caseSteps && phaseName) {
			const currentPhase = caseSteps.status.find((item) =>
				phaseName.includes(item.fase_name)
			);
			const currentStep = currentPhase?.steps.find(
				(item) => stepName === item.name
			);
			setStepId(currentStep?.step_id);
		}
	}, [stepName, caseSteps, phaseName]);

	return {
		phaseId,
		stepId,
	};
};
